import Vue from "vue";

Vue.component("wto-tag-input-no-data-source", {
	props: ["label", "placeholder", "output", "splitter"],
	computed: {
		computedValue: {
			get() {
				const text = this.output;
				if (!text) return [];
				const splitter = !this.splitter ? "," : this.splitter;
				return this.output.split(splitter);
			},
			set(value) {
				if (value) {
					const splitter = !this.splitter ? "," : this.splitter;
					this.$emit("update:output", value.join(splitter));
				}
			}
		}
	},
	template: `
		<b-field :label="label">
			<b-taginput v-model="computedValue"
						ellipsis
						icon="label"
						:placeholder="placeholder"
						aria-close-label="Delete this link">
			</b-taginput>
		</b-field>
	`
});